import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NAV_ROUTE } from '../services/navigation/navigation.service';
import { StateService } from '../services/state/state.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardPageGuard {
  constructor(
    private state: StateService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.state.isMobileScreen.value) {
      return this.router.parseUrl(NAV_ROUTE.HOME);
    }
    return true;
  }
  
}
